import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { updateUser } from '../actions'
import { Field, reduxForm, submit } from 'redux-form';
import { Form, Icon, Input, Button, Checkbox, Switch, Alert } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import './Profile.css'
import makeField from './makeField'

export const minLength = min => value =>
  value && value.length < min ? `Too short, use at least ${min} characters` : undefined

const AInput = makeField(Input);
const ASwitch = makeField(Switch);


const CommunicationPrefs = ({handleSubmit, pristine, invalid, submitting, submitSucceeded, error, reset}) =>
  <Card>
    <form onSubmit={handleSubmit}>
      <CardHeader
        title="Communication Preferences"
        buttonDisabled={pristine || submitting}
        buttonTitle="Save"
        buttonLoading={submitting}
        buttonHtmlType="submit"
        buttonClassName="ant-btn-primary"
      />

      <Field
        name="weekly_report_enabled"
        type="checkbox"
        component={ASwitch}
        label="Weekly Report"
      />

      <Field
        name="monthly_report_enabled"
        type="checkbox"
        component={ASwitch}
        label="Monthly Report"
      />

      <Field
        name="yearly_report_enabled"
        type="checkbox"
        component={ASwitch}
        label="Yearly Report"
      />

      <Field
        name="push_notifications_enabled"
        type="checkbox"
        component={ASwitch}
        label="Push Notifications"
      />

      <Field
        name="promotions_enabled"
        type="checkbox"
        component={ASwitch}
        label="Promotions"
      />

      { submitSucceeded ? <Alert message="User has been updated." type="success" /> : null}
      { error && <Alert message={error} type="error" />}
    </form>
  </Card>



  const mapStateToProps = (state, ownProps) => {
    const {user} = state.models
    return {
      initialValues: {
        weekly_report_enabled: user.weekly_report_enabled,
        monthly_report_enabled: user.monthly_report_enabled,
        yearly_report_enabled: user.yearly_report_enabled,
        push_notifications_enabled: user.push_notifications_enabled,
        promotions_enabled: user.promotions_enabled
      },
      enableReinitialize: true,
    }
  }

  export default connect( mapStateToProps )(
    reduxForm({
      form: 'communicationPrefs',
      onSubmit: (values, dispatch)=> dispatch(updateUser(values)),
    })(CommunicationPrefs)
  )



// WEBPACK FOOTER //
// ./src/account/profile/CommunicationPrefs.jsx